import type { TourStep } from './Tour';

/** The Projects screen. The guide and pairing steps only appear for those who see those links. */
export const HOME_TOUR: TourStep[] = [
  { target: 'projects', title: 'Projects', body: 'Choose a client or search for a project. Open it to see documents, outstanding amends and unanswered questions, with recent activity first.' },
  { target: 'notifications', title: 'Notifications', body: 'Choose which emails you get, per project.' },
  { target: 'guide', title: 'Guide', body: 'A short guide to reviewing proofs, adding amends, answering questions and resolving feedback.' },
  { target: 'pair', title: 'Link InDesign', body: 'Link the InDesign panel to your account.' },
];

/** The draft viewer for a signed-in user. Approve is there only for those who can approve. */
export const VIEWER_TOUR: TourStep[] = [
  { target: 'pages', title: 'Pages', body: 'Move between spreads.', placement: 'right' },
  { target: 'zoom', title: 'Zoom', body: 'Zoom in or out, or fit the spread to the window.' },
  { target: 'comment', title: 'Comment', body: 'Click Comment, then anywhere on the page, to start a thread.' },
  { target: 'editor', title: 'Edit', body: 'Click any text to edit it; it reflows in the real layout.', placement: 'left' },
  { target: 'threads', title: 'Questions and replies', body: 'Open a thread to reply, mark a question as answered, or resolve it once addressed.' },
  { target: 'changes', title: 'Changes', body: 'Every edit and its status, yours and others\'.' },
  { target: 'send', title: 'Send to designer', body: 'Send your edits to the designer.' },
  { target: 'preview', title: 'PDF preview', body: 'A PDF of the draft as it stands.' },
  { target: 'approve', title: 'Approve', body: 'Approve the draft as final. You can withdraw approval later.' },
  { target: 'drafts', title: 'Drafts', body: 'Earlier drafts and what changed.' },
];

/** The same viewer seen through a share link: pages, comments and threads only. */
export const GUEST_TOUR: TourStep[] = [
  { target: 'pages', title: 'Pages', body: 'Move between spreads.', placement: 'right' },
  { target: 'comment', title: 'Comment', body: 'Click Comment, then anywhere on the page, to start a thread.' },
  { target: 'threads', title: 'Threads', body: 'Reply to any thread; the team is notified.' },
];
